const formatFacet = (value, field) => {
  return `${field}:${value}`;
};

const formatFilterQuery = (query, field) => {
  if (!query) {
    return '';
  }
  if (typeof query === 'string' && query.includes(' OR ')) {
    const fullQuery = query
      .split(' OR ')
      .map((value) => {
        if (Number.isNaN(Number(value))) {
          return `${field}:"${value}"`;
        }
        return `${field}=${value}`;
      })
      .join(' OR ');
    return `(${fullQuery})`;
  }

  if (Number.isNaN(Number(query))) {
    return `${field}:"${query}"`;
  }
  return `${field}=${query}`;
};

const formatCheckboxesFacets = (fieldId, fieldValues) => {
  if (!fieldValues.length || !fieldId) {
    return null;
  }

  return fieldValues.map((value) => {
    return formatFacet(value, fieldId);
  });
};

const collectFacetQuery = (filters) => {
  const facets = [];
  const facetNames = window.drupalSettings.algoliaSearch.facet.facetKey;
  Object.entries(filters).forEach(([key, value]) => {
    let facet = '';
    if (facetNames.indexOf(key) > -1) {
      if (value) {
        if (Array.isArray(value)) {
          facet = formatCheckboxesFacets(key, value);
        }
        if (typeof value === 'string') {
          facet = formatFacet(value, key);
        }
      }
      if (facet) {
        facets.push(facet);
      }
    }
  });

  return facets;
};

const formatFilters = (fieldValues) => {
  if (!fieldValues.length) {
    return null;
  }
  let result = '';

  fieldValues.forEach((value) => {
    result += value && result ? ` AND ${value}` : value;
  });

  return result;
};

const collectFilterQuery = (filters) => {
  let queries = [];
  Object.entries(filters).forEach(([filterKey, value]) => {
    if (Array.isArray(value)) {
      let query = '';

      // Array of objects.
      if (value.length && typeof value[0] === 'object') {
        value.forEach((item) => {
          query += query ? ` OR ${item.value}` : item.value;
        });

        queries = [...queries, formatFilterQuery(query, filterKey)];
      } else {
        // Array of strings.
        value.forEach((item) => {
          query += query ? ` OR ${item}` : item;
        });

        queries = [...queries, formatFilterQuery(query, filterKey)];
      }
    } else {
      queries = [...queries, formatFilterQuery(value, filterKey)];
    }
  });

  return formatFilters(queries);
};

export { collectFacetQuery, collectFilterQuery, formatFilters };
